import { inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'

export const BreadcrumbResolver = (route: ActivatedRouteSnapshot): string => {
   const dvmId = route.paramMap.get('dvmId')
   return `Engagement Plan`
}
